import { render, staticRenderFns } from "./ViewImportedData.vue?vue&type=template&id=42516ce2&scoped=true&"
import script from "./ViewImportedData.vue?vue&type=script&lang=js&"
export * from "./ViewImportedData.vue?vue&type=script&lang=js&"
import style0 from "./ViewImportedData.vue?vue&type=style&index=0&id=42516ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42516ce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
